import { every } from 'lodash/fp';
import isNumeric from './isNumeric';
export var areNumeric = every(isNumeric);
export default areNumeric;